import { Component, Inject, OnInit, AfterViewInit, PLATFORM_ID } from '@angular/core';
import { isPlatformServer, Location } from "@angular/common";
import { I18nService } from "@biletix/core/services/i18n.service";
import { LocaleSelectorComponent } from "@biletix/core/common/locale-selector.component";
import { TranslateService } from "@ngx-translate/core";
import { RegionService } from "@biletix/core/services/region.service";
import { ConsoleLogger } from "@biletix/core/logging/console.logger";
import { AuthenticationService } from "@biletix/core/services/authentication.service";
import { GptAdService } from "@biletix/core/services/gpt-ad.service";

@Component({
    standalone: false,
    selector: 'btx-wide-layout',
    templateUrl: './wide-layout.component.html',
    styleUrls: ['./wide-layout.component.scss']
})
export class WideLayoutComponent extends LocaleSelectorComponent implements OnInit, AfterViewInit {

    isServer = false;

    constructor(private location: Location,
        public i18n: I18nService,
        public region: RegionService,
        private authenticationService: AuthenticationService,
        private translate: TranslateService,
        private logger: ConsoleLogger,
        private gptAdService: GptAdService,
        @Inject(PLATFORM_ID) platformId: Object,
    ) {
        super(translate, i18n);
        this.isServer = isPlatformServer(platformId);
    }

    ngOnInit(): void {
        this.initialize();
    }

    ngAfterViewInit(): void {
        this.gptAdService.displayAndRefreshAds([
            'div-gpt-ad-1594640818191-0',
            'div-gpt-ad-1505377893829-0'
        ]);
    }

    initialize() {
        this.clearLocalStorage();
    }

    clearLocalStorage() {
        //clear cache
        this.authenticationService.removeLoggedInAnonymousCustomer();
    }


    onBack() {
        this.location.back();
    }


}
